export const PolicyActionTypes = {
    LOGOUT: 'LOGOUT',

    ADD_POLICY_REQUEST: 'ADD_POLICY_REQUEST',
    ADD_POLICY_REQUEST_SUCCESS: 'ADD_POLICY_REQUEST_SUCCESS',
    ADD_POLICY_REQUEST_ERROR: 'ADD_POLICY_REQUEST_ERROR',
    ADD_POLICY_REQUEST_STATUS: 'ADD_POLICY_REQUEST_STATUS',

    POLICY_LIST_REQUEST: 'POLICY_LIST_REQUEST',
    POLICY_LIST_REQUEST_SUCCESS: 'POLICY_LIST_REQUEST_SUCCESS',
    POLICY_LIST_REQUEST_ERROR: 'POLICY_LIST_REQUEST_ERROR',

    POLICY_DETAIL_REQUEST: 'POLICY_DETAIL_REQUEST',
    POLICY_DETAIL_REQUEST_SUCCESS: 'POLICY_DETAIL_REQUEST_SUCCESS',
    POLICY_DETAIL_REQUEST_ERROR: 'POLICY_DETAIL_REQUEST_ERROR',

    ASSIGN_POLICY_REQUEST: 'ASSIGN_POLICY_REQUEST',
    ASSIGN_POLICY_REQUEST_SUCCESS: 'ASSIGN_POLICY_REQUEST_SUCCESS',
    ASSIGN_POLICY_REQUEST_ERROR: 'ASSIGN_POLICY_REQUEST_ERROR',
    ASSIGN_POLICY_REQUEST_STATUS: 'ASSIGN_POLICY_REQUEST_STATUS',

    POLICY_MARK_COMPLETE_REQUEST: 'POLICY_MARK_COMPLETE_REQUEST',
    POLICY_MARK_COMPLETE_REQUEST_SUCCESS: 'POLICY_MARK_COMPLETE_REQUEST_SUCCESS',
    POLICY_MARK_COMPLETE_REQUEST_ERROR: 'POLICY_MARK_COMPLETE_REQUEST_ERROR',
    POLICY_MARK_COMPLETE_REQUEST_STATUS: 'POLICY_MARK_COMPLETE_REQUEST_STATUS'
}